<template>
     <div class="indexfoot">
          <div class="w1200 flex">
            <div class="flex-1">
              <div class="f18">{{config.copyright}}</div>
              <div class="f14 mt_10">{{config.gxbba}}   {{config.ggwba}}</div>

            </div>
            <img src="@/assets/ffflogo.png" class="logo2">
          </div>
      </div>
</template>

<script>
import { getconfig } from "@/api/index.js"
export default {
  name: "HomePage",
  data() {
    return {
       config:JSON.parse(localStorage.getItem("config"))
    }
  },
  created() {
    // this.$http({
    //   method: "POST",
    //   url: "/jobhunter/job/getJobs",
    //   data: {
    //     uid: sessionStorage.getItem("uid"),
    //   }
    // }).then((res)=>{
    //   this.joblist = res.data;
    // }).catch(()=>{
    //   this.$message.error('工作信息获取异常');
    // })
  },
  mounted(){
    if(this.config==undefined||this.config==null){
         getconfig().then(res=>{
          if(res.code==1){
            this.config=res.data;
          }
        })
    }
  },
  methods:{
    
  }
}
</script>

<style scoped lang="less">
 .indexfoot {
    background:#002855;margin-top:80px;color:#fff;padding-top:30px;padding-bottom: 30px;
      .logo2 {height:60px;}
   }

</style>
